import { Icon } from '@iconify/react';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { pageTitle } from '../../helper';
import Cta from '../Cta';
import PageHeading from '../PageHeading';
import Portfolio from '../Portfolio';
import Div from '../Div';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';
import axios from 'axios';
import BASE_URL from '../../utils/api';



export default function ProductsPage() {
  pageTitle('Products');

  const [active, setActive] = useState('all');
  const [itemShow, setItemShow] = useState(7);
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);


  useEffect(() => {
    window.scrollTo(0, 0);

    axios.get(`${BASE_URL}/api/products`)
      .then(res => setProducts(res.data))
      .catch(err => console.error('Error fetching products', err));

    axios.get(`${BASE_URL}/api/productCategories`)
      .then(res => setCategories(res.data))
      .catch(err => console.error('Error fetching categories', err));
  }, []);



  return (
    <>
      <PageHeading
        title="Products"
        bgSrc="images/portfolio_hero_bg.jpeg"
        pageLinkText="All Products"
      />
      <Spacing lg="145" md="80" />
      <Div className="container">
        <Div className="cs-portfolio_1_heading" data-aos="fade-up" data-aos-duration="2000">
          <SectionHeading title="Our Best Products" subtitle="Our products" />
          <Div className="cs-filter_menu cs-style1">
            <ul className="cs-mp0 cs-center">
              <li className={active === 'all' ? 'active' : ''}>
                <span onClick={() => setActive('all')}>All</span>
              </li>
              {categories.map((item, index) => (
                <li className={active === item._id ? 'active' : ''} key={item._id}>
                  <span onClick={() => setActive(item._id)}>{item.categoryName}</span>
                </li>
              ))}
            </ul>
          </Div>
        </Div>
        <Spacing lg="90" md="45" />
        <Div className="row" data-aos="fade-up" data-aos-duration="2000">
          {products
          .filter(item => active === 'all' || item.productCatId._id === active)
          .slice(0, itemShow)
          .map((item, index) => (
            <Div
              className={`${
                index === 3 || index === 6 ? 'col-lg-8' : 'col-lg-4'
              }`}
              key={index}
            >
              <Portfolio
                title={item.productName}
                subtitle={`LKR ${item.productPrice.$numberDecimal}`}
                href={`/product/${item._id}`}
                src={item.productImages[0]}
                variant="cs-style1 cs-type1"
              />
              <Spacing lg="25" md="25" />
            </Div>
          ))}
        </Div>

        <Div className="text-center" data-aos="fade-up" data-aos-duration="2000">
          {products.length <= itemShow ? (
            ''
          ) : (
            <>
              <Spacing lg="65" md="40" />
              <span className="cs-text_btn" onClick={() => setItemShow(itemShow + 3)}>
                <span>Load More</span>
                <Icon icon="bi:arrow-right" />
              </span>
            </>
          )}
        </Div>
      </Div>
      <Spacing lg="145" md="80" />
      <Cta
        title="Lixr Innovation"
        bgSrc="/images/cta_bg_2.jpeg"
        variant="rounded-0"
      />
    </>
  );
}
